import gqlTagGira from 'graphql-tag';

export const GET_DATA_QUERY = gqlTagGira`
query getPublicFormChangeboardingData ($projectId: Long!, $projectAri: ID!) {
    jira {
        containerNavigation(
            input: {scopeId: $projectAri}
        ) {
            ... on JiraContainerNavigation {
                id
                navigationItems(first: 100) {
                    edges {
                        node {
                            typeKey
                            id
                        }
                    }
                }
            }
        }

        jiraProject(id: $projectAri) {
            id
            projectId
            key
            name
            projectType
			tmpBoardId
            administerProject: action(type: EDIT_PROJECT_CONFIG) {
              canPerform
            }
            issueTypes(
                first: 1,
                filter: { minHierarchyLevel: 0, maxHierarchyLevel: 0 }
            ) {
                edges {
                    node {
                        id
                        name
                        issueTypeId
                    }
                }
            }
        }
    }

    jiraBusinessFormsByProjectId(projectId: $projectId, first: 50) {
        publicFormsEnabled
        nodes {
            formId
            accessLevel
        }
    }
}
`;
